import { createActions, createReducer } from "reduxsauce";
import { defaultState } from "./multiple-realms-model";

export const showLoading = (state) => ({
  ...state,
  isLoading: true,
});

export const hideLoading = (state) => ({
  ...state,
  isLoading: false,
});

export const disabledRegisterButton = (state = defaultState) => ({
  ...state,
  disabledRegisterButton: true,
});

export const enableRegisterButton = (state = defaultState) => ({
  ...state,
  disabledRegisterButton: false,
});

export const { Types, Creators } = createActions({
  multipleRealmsShowLoading: [],
  multipleRealmsHideLoading: [],
  multipleRealmsEnabledRegisterButton: [],
  multipleRealmsDisabledRegisterButton: [],
  multipleRealmsGetSsoCredentialsAsync: [],
  multipleRealmsGetTokenAsync: ["realmName", "authorizationCode"],
  multipleRealmsSaveUserInfoAsync: ["locationId", "locationDescription", "name", "email", "language"],
});

export default createReducer(defaultState, {
  [Types.MULTIPLE_REALMS_SHOW_LOADING]: showLoading,
  [Types.MULTIPLE_REALMS_HIDE_LOADING]: hideLoading,
  [Types.MULTIPLE_REALMS_DISABLED_REGISTER_BUTTON]: disabledRegisterButton,
  [Types.MULTIPLE_REALMS_ENABLED_REGISTER_BUTTON]: enableRegisterButton,
});
